import config from "../config";

// Shopify's CDN resizes on request (`width` / `height`, aspect ratio kept), so
// a drawer never downloads a multi-megabyte original. Other hosts get the URL
// unchanged.
const SHOPIFY_CDN_HOST = "cdn.shopify.com";

/**
 * <img> src for a product image as the backend returns it: `{ url, key }`,
 * where `url` is a direct link (e.g. Shopify CDN) and `key` an S3 key served
 * by /fetch-file. Null when there is no image.
 */
export const productImageSrc = (image, { width, height } = {}) => {
  if (image?.url) {
    if (!width && !height) return image.url;
    try {
      const url = new URL(image.url);
      if (url.hostname !== SHOPIFY_CDN_HOST) return image.url;
      if (width) url.searchParams.set("width", String(width));
      if (height) url.searchParams.set("height", String(height));
      return url.toString();
    } catch {
      return image.url;
    }
  }
  if (image?.key) return `${config.baseURL}/fetch-file/${image.key}`;
  return null;
};
